import { render, staticRenderFns } from "./BankStatementList.vue?vue&type=template&id=350c5e9f"
import script from "./BankStatementList.vue?vue&type=script&lang=js"
export * from "./BankStatementList.vue?vue&type=script&lang=js"
import style0 from "./BankStatementList.vue?vue&type=style&index=0&id=350c5e9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports